import React, { useState, useEffect, useRef } from 'react';
import { 
  FaStar, 
  FaStarHalfAlt, 
  FaQuoteLeft, 
  FaQuoteRight, 
  FaChevronLeft, 
  FaChevronRight,
  FaUserCircle,
  FaMapMarkerAlt,
  FaTaxi,
  FaRegClock
} from 'react-icons/fa';
import { MdVerified, MdRateReview, MdLocationOn } from 'react-icons/md';
import { FaSmile, FaCar } from 'react-icons/fa';


const testimonials = [
  {
    id: 1,
    name: "Rahul Sharma",
    location: "T Nagar, Chennai",
    image: "https://media.istockphoto.com/id/1277971635/photo/portrait-of-a-smiling-man-of-indian-ethnicity.jpg?s=612x612&w=0&k=20&c=CnPwvagPlklsAjejUNkuKv_QXtaXPYFQ64AQYb-IAjA=",
    rating: 5,
    date: "2 days ago",
    rideType: "Airport Transfer",
    vehicle: "Toyota Innova Crysta",
    comment: "Best cab service in Chennai! Booked an Innova for airport transfer. Driver was professional, car was spotless, and reached the airport with plenty of time. The real-time tracking feature is super helpful. Safe Track Cab Service truly lives up to their name!",
    initials: "RS"
  },
  {
    id: 2,
    name: "Priya Krishnan",
    location: "Koramangala, Chennai",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTH86R2UEZc7rEOYGar1gMdU4PrcJBluPh8uw&s",
    rating: 5,
    date: "1 week ago",
    rideType: "Outstation Trip",
    vehicle: "Sedan (Honda City)",
    comment: "Took an outstation trip to Pondicherry with Safe Track. The car was comfortable and the driver knew the route well. Reasonable pricing and no hidden charges. Will definitely use Safe Track Cab Service again!",
    initials: "PK"
  },
  {
    id: 3,
    name: "Anand Kumar",
    location: "Velachery, Chennai",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeAwefXOC8OA_exudU55j6oDQulIN7reiMvQ&s",
    rating: 4.5,
    date: "3 days ago",
    rideType: "Daily Office Commute",
    vehicle: "Hatchback (Swift Dzire)",
    comment: "Been using Safe Track for my daily office commute for 3 months now. Never had a cancellation. Drivers are always on time. The monthly pass option saved me a lot of money. Best decision for my daily travel!",
    initials: "AK"
  },
  {
    id: 4,
    name: "Deepa Nair",
    location: "Adyar, Chennai",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbFfSyFj0gaw5Jy3Tg29F5IQ1dNy802K-tNA&s",
    rating: 5,
    date: "5 days ago",
    rideType: "Wedding Event",
    vehicle: "Sedan (Toyota Etios)",
    comment: "Booked 3 Sedan Vehicles for my sister's wedding in Chennai. The coordination was seamless. All cars arrived on time, drivers were courteous, and the cars were decorated beautifully. Thank you Safe Track Cab Service!",
    initials: "DN"
  },
  {
    id: 5,
    name: "Suresh Babu",
    location: "Porur, Chennai",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmvpC4o7KTxoDJ-HtuqKQuS0hWPbEt01ZZYQ&s",
    rating: 4,
    date: "1 week ago",
    rideType: "Weekend Trip",
    vehicle: "Tempo Traveller",
    comment: "Great experience with the Sedan Vehicle Swift Dzire from Safe Track for a weekend trip to Mahabalipuram. Vehicle was well-maintained and the driver was experienced. Reasonable rates too.",
    initials: "SB"
  },
  {
    id: 6,
    name: "Kavitha Rao",
    location: "Mylapore, Chennai",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQWZl7XR64hOzFFqeOEtr1aXeUh4eUite0_DA&s",
    rating: 5,
    date: "2 weeks ago",
    rideType: "Airport Drop",
    vehicle: "Premium Sedan",
    comment: "The best part about Safe Track Cab Service is their punctuality. My 5 AM airport drop was right on time. The driver even helped with luggage. Highly recommend for early morning flights from Chennai!",
    initials: "KR"
  },
  {
    id: 7,
    name: "Vikram Mehta",
    location: "OMR, Chennai",
    image: "https://insertface.com/fb/3533/engagement-dress-male-indian-3533191-fhkyn-fb.webp",
    rating: 5,
    date: "4 days ago",
    rideType: "Business Meeting",
    vehicle: "Mercedes E-Class",
    comment: "Booked their Sedan Vehicle for an important client meeting in Chennai. Made a great impression! The car was immaculate, driver was in formal wear, and everything was perfect. Worth every penny with Safe Track.",
    initials: "VM"
  },
  {
    id: 8,
    name: "Lakshmi Prasad",
    location: "Anna Nagar, Chennai",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShmi5u6jzsJKd_fTBPVxMNOHuOy9u9WMgcxA&s",
    rating: 4.5,
    date: "1 week ago",
    rideType: "Temple Visit",
    vehicle: "Ertiga",
    comment: "Used Safe Track Cab Service for a family temple visit to Tirupati. Comfortable journey, patient driver, and fair pricing. The kids loved the experience. Will book again for our next Chennai trip!",
    initials: "LP"
  }
];

// Rating Stars Component
const RatingStars = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  
  return (
    <div style={styles.ratingContainer}>
      {[...Array(fullStars)].map((_, i) => (
        <FaStar key={i} style={styles.starFilled} />
      ))}
      {hasHalfStar && <FaStarHalfAlt style={styles.starFilled} />}
      {[...Array(5 - Math.ceil(rating))].map((_, i) => (
        <FaStar key={`empty-${i}`} style={styles.starEmpty} />
      ))}
    </div>
  );
};

// Avatar Component (shows initials if no image)
const Avatar = ({ name, initials, image, size = 50 }) => {
  const getRandomColor = () => {
    const colors = ['#28aa96', '#28aa96', '#FFF0B5', '#FFF9E6', '#28aa96'];
    const index = (name.length + initials.charCodeAt(0)) % colors.length;
    return colors[index];
  };

  if (image) {
    return (
      <img 
        src={image} 
        alt={name}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          objectFit: 'cover',
          border: '2px solid #28aa96',
        }}
      />
    );
  }

  return (
    <div style={{
      ...styles.avatar,
      width: size,
      height: size,
      fontSize: size * 0.4,
      backgroundColor: getRandomColor(),
      color: '#000000',
    }}>
      {initials}
    </div>
  );
};

// Testimonial Card Component
const TestimonialCard = ({ testimonial, isActive }) => {
  return (
    <div style={{
      ...styles.card,
      ...(isActive ? styles.cardActive : {})
    }}>
      {/* Header with Avatar and Rating */}
      <div style={styles.cardHeader}>
        <div style={styles.userInfo}>
          <Avatar 
            name={testimonial.name} 
            initials={testimonial.initials} 
            image={testimonial.image}
            size={50} 
          />
          <div style={styles.userDetails}>
            <h3 style={styles.userName}>{testimonial.name}</h3>
            <div style={styles.locationWrapper}>
              <MdLocationOn style={styles.locationIcon} />
              <span style={styles.userLocation}>{testimonial.location}</span>
            </div>
          </div>
        </div>
        <RatingStars rating={testimonial.rating} />
      </div>

      {/* Quote Icon */}
      <div style={styles.quoteIcon}>
        <FaQuoteLeft style={styles.quoteLeft} />
      </div>

      {/* Testimonial Text */}
      <p style={styles.testimonialText}>"{testimonial.comment}"</p>

      {/* Footer with Ride Details */}
      <div style={styles.cardFooter}>
        <div style={styles.rideDetails}>
          <span style={styles.rideTypeBadge}>
            <FaTaxi style={styles.rideIcon} /> {testimonial.rideType}
          </span>
          <span style={styles.vehicleInfo}>
            {testimonial.vehicle}
          </span>
        </div>
        <div style={styles.dateWrapper}>
          <FaRegClock style={styles.dateIcon} />
          <span style={styles.dateText}>{testimonial.date}</span>
        </div>
      </div>

      {/* Verified Badge */}
      <div style={styles.verifiedBadge}>
        <MdVerified style={styles.verifiedIcon} />
        <span style={styles.verifiedText}>Verified Customer</span>
      </div>
    </div>
  );
};

export default function TestimonialSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [activeFilter, setActiveFilter] = useState('All');
  const [filteredTestimonials, setFilteredTestimonials] = useState(testimonials);
  const scrollRef = useRef(null);

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Filter options
  const filters = ['All', 'Airport Transfer', 'Outstation', 'Daily Commute', 'Events', 'Luxury'];

  // Handle filter change
  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    if (filter === 'All') {
      setFilteredTestimonials(testimonials);
    } else {
      const filtered = testimonials.filter(t => 
        t.rideType.toLowerCase().includes(filter.toLowerCase()) ||
        (filter === 'Luxury' && t.vehicle.includes('Mercedes')) ||
        (filter === 'Events' && t.rideType.includes('Wedding'))
      );
      setFilteredTestimonials(filtered);
    }
    setCurrentIndex(0);
  };

  // Navigation handlers
  const nextSlide = () => {
    if (currentIndex < filteredTestimonials.length - (isMobile ? 1 : 3)) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Mobile scroll handler
  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    scrollRef.current = {
      startX: touch.clientX,
      startY: touch.clientY
    };
  };

  const handleTouchMove = (e) => {
    if (!scrollRef.current) return;
    
    const touch = e.touches[0];
    const diffX = scrollRef.current.startX - touch.clientX;
    const diffY = Math.abs(scrollRef.current.startY - touch.clientY);
    
    if (Math.abs(diffX) > diffY && Math.abs(diffX) > 50) {
      e.preventDefault();
      if (diffX > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
      scrollRef.current = null;
    }
  };

  // Statistics
 const stats = [
  { 
    value: '10+', 
    label: 'Happy Riders', 
    icon: <FaSmile style={{ color: '#000000', fontSize: 24 }} /> 
  },
  { 
    value: '4.4★', 
    label: 'Rating', 
    icon: <FaStar style={{ color: '#000000', fontSize: 24 }} /> 
  },
  { 
    value: '25+', 
    label: 'Chennai Locations', 
    icon: <MdLocationOn style={{ color: '#000000', fontSize: 24 }} /> 
  },
  { 
    value: '100+', 
    label: 'Daily Rides', 
    icon: <FaCar style={{ color: '#000000', fontSize: 24 }} /> 
  }
];

  return (
    <div style={styles.container}>
      {/* Header Section */}
      <div style={styles.header}>
        <div style={styles.headerBadge}>
          <MdRateReview style={styles.headerIcon} /> RAVES & REVIEWS
        </div>
        <h1 style={styles.title}>
          What Our <span style={styles.titleAccent}>Chennai Customers Say</span>
        </h1>
        <p style={styles.subtitle}>
          Real experiences from our customers across the Chennai city
        </p>
      </div>

      {/* Stats Cards */}
      <div style={styles.statsContainer}>
        {stats.map((stat, idx) => (
          <div key={idx} style={styles.statCard}>
            <span style={styles.statIcon}>{stat.icon}</span>
            <div style={styles.statValue}>{stat.value}</div>
            <div style={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>

      {/* Filter Tabs - Scrollable on Mobile */}
      <div style={styles.filterContainer}>
        <div style={styles.filterScroll}>
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => handleFilterChange(filter)}
              style={{
                ...styles.filterButton,
                ...(activeFilter === filter ? styles.filterButtonActive : {})
              }}
            >
              {filter}
            </button>
          ))}
        </div>
      </div>

      {/* Testimonials Carousel/Grid */}
      <div 
        style={styles.testimonialsWrapper}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        {/* Navigation Arrows - Desktop Only */}
        {!isMobile && filteredTestimonials.length > 3 && (
          <>
            <button 
              onClick={prevSlide} 
              style={{
                ...styles.navButton,
                ...styles.navButtonLeft,
                ...(currentIndex === 0 ? styles.navButtonDisabled : {})
              }}
              disabled={currentIndex === 0}
            >
              <FaChevronLeft />
            </button>
            <button 
              onClick={nextSlide} 
              style={{
                ...styles.navButton,
                ...styles.navButtonRight,
                ...(currentIndex >= filteredTestimonials.length - 3 ? styles.navButtonDisabled : {})
              }}
              disabled={currentIndex >= filteredTestimonials.length - 3}
            >
              <FaChevronRight />
            </button>
          </>
        )}

        {/* Cards Container */}
        <div style={{
          ...styles.cardsContainer,
          ...(isMobile ? styles.cardsContainerMobile : {}),
          transform: isMobile ? 'none' : `translateX(-${currentIndex * (100 / 3)}%)`,
        }}>
          {filteredTestimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id}
              style={{
                ...styles.cardWrapper,
                ...(isMobile ? styles.cardWrapperMobile : {}),
              }}
            >
              <TestimonialCard 
                testimonial={testimonial} 
                isActive={!isMobile && index >= currentIndex && index < currentIndex + 3}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Dots Indicator - Mobile */}
      {isMobile && filteredTestimonials.length > 1 && (
        <div style={styles.dotsContainer}>
          {filteredTestimonials.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              style={{
                ...styles.dot,
                ...(idx === currentIndex ? styles.dotActive : {})
              }}
            />
          ))}
        </div>
      )}

      {/* Chennai Map Preview */}
      <div style={styles.mapPreview}>
        <div style={styles.mapContent}>
          <FaMapMarkerAlt style={styles.mapIcon} />
          <div style={styles.mapText}>
            <h3 style={styles.mapTitle}>Serving All of Chennai</h3>
            <p style={styles.mapSubtitle}>From T Nagar to OMR, we cover every corner of the city</p>
          </div>
          <button style={styles.mapButton} onClick={() => window.open("https://maps.google.com/?q=Chennai,Tamil+Nadu", "_blank")}>
            View Coverage →
          </button>
        </div>
      </div>

      {/* Write a Review CTA */}
      <div style={styles.reviewCTA}>
        <h3 style={styles.ctaTitle}>Share Your Experience with Safe Track</h3>
        <p style={styles.ctaText}>Help us serve you better and help others choose wisely in Chennai</p>
        <button style={styles.ctaButton} onClick={() => window.location.href = "mailto:micheal0703.mr@gmail.com"}>
          Write a Review <span style={styles.ctaArrow}>→</span>
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '20px 16px 40px',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    backgroundColor: '#FFFFFF',
    minHeight: '100vh',
  },
  header: {
    textAlign: 'center',
    marginBottom: 32,
  },
  headerBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    backgroundColor: '#28aa96',
    padding: '8px 20px',
    borderRadius: 30,
    fontSize: 13,
    fontWeight: 600,
    color: '#000000',
    marginBottom: 16,
    letterSpacing: 1,
  },
  headerIcon: {
    fontSize: 16,
  },
  title: {
    fontSize: 'clamp(32px, 8vw, 48px)',
    fontWeight: 700,
    color: '#000000',
    marginBottom: 12,
    lineHeight: 1.2,
  },
  titleAccent: {
    color: '#28aa96',
    display: 'block',
    '@media (min-width: 768px)': {
      display: 'inline',
    },
  },
  subtitle: {
    fontSize: 'clamp(14px, 4vw, 16px)',
    color: '#666666',
    maxWidth: 600,
    margin: '0 auto',
    lineHeight: 1.6,
  },
  statsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 12,
    marginBottom: 32,
    '@media (max-width: 600px)': {
      gap: 8,
    },
  },
  statCard: {
    backgroundColor: '#FFFDF0',
    borderRadius: 16,
    padding: '16px 8px',
    textAlign: 'center',
    border: '1px solid #28aa96',
    boxShadow: '0 4px 12px rgba(255,215,0,0.1)',
  },
  statIcon: {
    fontSize: 24,
    display: 'block',
    marginBottom: 8,
  },
  statValue: {
    fontSize: 'clamp(16px, 4vw, 20px)',
    fontWeight: 700,
    color: '#000000',
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 'clamp(10px, 3vw, 12px)',
    color: '#666666',
  },
  filterContainer: {
    marginBottom: 24,
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
  filterScroll: {
    display: 'flex',
    gap: 10,
    paddingBottom: 8,
    minWidth: 'max-content',
  },
  filterButton: {
    padding: '10px 20px',
    borderRadius: 30,
    border: '1.5px solid #28aa96',
    backgroundColor: '#FFFFFF',
    fontSize: 14,
    fontWeight: 600,
    color: '#666666',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#FFF9E6',
    },
  },
  filterButtonActive: {
    backgroundColor: '#28aa96',
    borderColor: '#28aa96',
    color: '#000000',
  },
  testimonialsWrapper: {
    position: 'relative',
    marginBottom: 24,
    overflow: 'hidden',
    padding: '8px 0',
  },
  navButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: '#FFFFFF',
    border: '2px solid #28aa96',
    color: '#28aa96',
    fontSize: 18,
    cursor: 'pointer',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#28aa96',
      color: '#FFFFFF',
    },
  },
  navButtonLeft: {
    left: 10,
  },
  navButtonRight: {
    right: 10,
  },
  navButtonDisabled: {
    opacity: 0.3,
    cursor: 'not-allowed',
    ':hover': {
      backgroundColor: '#FFFFFF',
      color: '#28aa96',
    },
  },
  cardsContainer: {
    display: 'flex',
    gap: 20,
    transition: 'transform 0.3s ease',
  },
  cardsContainerMobile: {
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    WebkitOverflowScrolling: 'touch',
    padding: '0 4px',
    gap: 16,
  },
  cardWrapper: {
    flex: '0 0 calc(33.333% - 14px)',
    minWidth: 280,
  },
  cardWrapperMobile: {
    flex: '0 0 85%',
    scrollSnapAlign: 'start',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 24,
    padding: 24,
    border: '1px solid #28aa96',
    boxShadow: '0 8px 24px rgba(255,215,0,0.12)',
    transition: 'all 0.3s ease',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  cardActive: {
    transform: 'scale(1.02)',
    borderColor: '#28aa96',
    boxShadow: '0 12px 32px rgba(255,215,0,0.2)',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
  },
  userInfo: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
  },
  avatar: {
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    border: '2px solid #28aa96',
  },
  userDetails: {
    flex: 1,
  },
  userName: {
    fontSize: 16,
    fontWeight: 600,
    color: '#000000',
    marginBottom: 4,
  },
  locationWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  locationIcon: {
    fontSize: 12,
    color: '#28aa96',
  },
  userLocation: {
    fontSize: 12,
    color: '#888888',
  },
  ratingContainer: {
    display: 'flex',
    gap: 2,
  },
  starFilled: {
    color: '#28aa96',
    fontSize: 14,
  },
  starEmpty: {
    color: '#E0E0E0',
    fontSize: 14,
  },
  quoteIcon: {
    marginBottom: 12,
  },
  quoteLeft: {
    color: '#28aa96',
    fontSize: 20,
    opacity: 0.5,
  },
  testimonialText: {
    fontSize: 14,
    color: '#444444',
    lineHeight: 1.7,
    marginBottom: 20,
    flex: 1,
    fontStyle: 'italic',
  },
  cardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
    paddingTop: 12,
    borderTop: '1px solid #FFF0B5',
  },
  rideDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  rideTypeBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    backgroundColor: '#FFFDF0',
    padding: '4px 10px',
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 600,
    color: '#B8860B',
  },
  rideIcon: {
    fontSize: 10,
  },
  vehicleInfo: {
    fontSize: 11,
    color: '#999999',
  },
  dateWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  dateIcon: {
    fontSize: 11,
    color: '#CCCCCC',
  },
  dateText: {
    fontSize: 11,
    color: '#999999',
  },
  verifiedBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 10px',
    backgroundColor: '#FFD966',
    borderRadius: 20,
    alignSelf: 'flex-start',
  },
  verifiedIcon: {
    color: '#2E7D32',
    fontSize: 12,
  },
  verifiedText: {
    fontSize: 10,
    fontWeight: 600,
    color: '#2E7D32',
  },
  dotsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    marginTop: 16,
    marginBottom: 24,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    border: 'none',
    backgroundColor: '#28aa96',
    cursor: 'pointer',
    padding: 0,
    transition: 'all 0.2s ease',
  },
  dotActive: {
    width: 24,
    backgroundColor: '#28aa96',
  },
  mapPreview: {
    marginTop: 40,
    marginBottom: 24,
    backgroundColor: '#000000',
    borderRadius: 24,
    padding: 24,
    border: '2px solid #28aa96',
  },
  mapContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
    justifyContent: 'center',
    '@media (min-width: 768px)': {
      justifyContent: 'space-between',
    },
  },
  mapIcon: {
    fontSize: 32,
    color: '#28aa96',
  },
  mapText: {
    flex: 1,
    textAlign: 'center',
    '@media (min-width: 768px)': {
      textAlign: 'left',
    },
  },
  mapTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#FFFFFF',
    marginBottom: 4,
  },
  mapSubtitle: {
    fontSize: 13,
    color: '#AAAAAA',
  },
  mapButton: {
    padding: '12px 24px',
    backgroundColor: '#28aa96',
    border: 'none',
    borderRadius: 30,
    fontSize: 14,
    fontWeight: 600,
    color: '#000000',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    ':hover': {
      transform: 'scale(1.05)',
    },
  },
  reviewCTA: {
    textAlign: 'center',
    padding: '32px 20px',
    backgroundColor: '#FFFDF0',
    borderRadius: 30,
    border: '1px solid #28aa96',
  },
  ctaTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: '#000000',
    marginBottom: 8,
  },
  ctaText: {
    fontSize: 14,
    color: '#666666',
    marginBottom: 20,
  },
  ctaButton: {
    padding: '14px 32px',
    backgroundColor: '#28aa96',
    border: 'none',
    borderRadius: 30,
    fontSize: 16,
    fontWeight: 600,
    color: '#000000',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    ':hover': {
      transform: 'scale(1.05)',
    },
  },
  ctaArrow: {
    fontSize: 18,
  },
};

// Add global styles
const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
  
  body {
    margin: 0;
    padding: 0;
    background-color: #FFFFFF;
  }
  
  * {
    box-sizing: border-box;
  }
`;

// Inject global styles
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = globalStyles;
  document.head.appendChild(style);
}